export default "/images/logo.png?93a70297204e70062db06908ad57f0fa";